/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import {ReactComponent as Chevron} from 'assets/icons/chevron-right.svg';

const Pager = ({meta, changePage, activePage}) => {
  const intl = useIntl();
  const {totalRows, pageSize, pageNumber: currentPage} = meta || {};
  const totalPages = meta?.totalPages ? meta.totalPages : Math.ceil(totalRows / pageSize);
  const [pages, setPages] = useState([]);

  useEffect(() => {
    if (typeof currentPage === 'number') {
      let range = [...Array(totalPages + 1).keys()];

      if (range.length > 5) {
        let start = 0;
        if (currentPage > 1) {

          if (currentPage > totalPages - 2) {
            start = totalPages - 4;
          }
          else {
            start = currentPage - 2;
          }
        }
        range = range.slice(start, start + 5);
      }
      setPages(range);
    }
  }, [currentPage, totalPages]);

  if ((!meta && activePage < 2) || totalPages < 2) {
    return '';
  }

  const renderPrevButton = () => {
    if (currentPage < 1) {
      return '';
    }

    return (
      <li className="pager__item pager__item--previous">
        <a href="#"
           title={intl.formatMessage({id: 'Pager.Previous.MetaTitle'})}
           rel="prev"
           onClick={(event) => changePage(event, currentPage - 1)}
        >
          <span className="visually-hidden">
            {intl.formatMessage({id: 'Pager.Previous.TextFull'})}
          </span>
          <Chevron/>
          <span className="pager__nav-button">
            {intl.formatMessage({id: 'Pager.Previous.Text'})}
          </span>
        </a>
      </li>
    );
  };

  const renderNextButton = () => {
    if (currentPage + 1 === totalPages) {
      return '';
    }

    return (
      <li className="pager__item pager__item--next">
        <a href="#"
           title={intl.formatMessage({id: 'Pager.Next.MetaTitle'})}
           rel="prev"
           onClick={(event) => changePage(event, currentPage + 1)}
        >
          <span className="visually-hidden">
            {intl.formatMessage({id: 'Pager.Next.TextFull'})}
          </span>
          <span className="pager__nav-button">
            {intl.formatMessage({id: 'Pager.Next.Text'})}
          </span>
          <Chevron/>
        </a>
      </li>
    );
  };

  const pageItem = (number) => {
    let metaTitle = '';
    let visuallyHiddenText = intl.formatMessage({id: 'Pager.Page.VisuallyHidden'});
    if (currentPage === number) {
      metaTitle = intl.formatMessage({id: 'Pager.Previous.MetaCurrent'});
      visuallyHiddenText = intl.formatMessage({id: 'Pager.Current.MetaCurrent'});
    }
    else if (number === 1) {
      metaTitle = intl.formatMessage({id: 'Pager.First.MetaFirst'});
    }
    else if (number === totalPages) {
      metaTitle = intl.formatMessage({id: 'Pager.Last.MetaLast'});
    }
    else {
      metaTitle = intl.formatMessage({id: 'Pager.Page.MetaPageNumber'}, {page: number})
    }

    return (
      <li
        className={`pager__item ${activePage === number ? 'is-active' : ''}`}
        key={number}>
        <a href="#" title={metaTitle} onClick={(event) => changePage(event, number)}>
          <span className="visually-hidden">
            {visuallyHiddenText}
          </span>
          {number + 1}
        </a>
      </li>
    );
  };

  const renderPageButtons = () => {
    return pages.map((page) => {
      return page + 1 > totalPages ? '' : pageItem(page);
    });
  };

  const renderEllipsis = (number) => {
    if (pages.includes(number)) {
      return '';
    }

    return (
      <li className="pager__item pager__item--ellipsis" role="presentation">&hellip;</li>
    );
  };

  const renderFirstAndLast = (number) => {
    if (pages.includes(number)) {
      return '';
    }

    return pageItem(number);
  };

  return (
    <nav className="pager" role="navigation" aria-labelledby="pagination">
      <ul className="pager__items js-pager__items flex justify-center">
        {renderPrevButton()}
        {renderFirstAndLast(0)}
        {renderEllipsis(1)}
        {renderPageButtons()}
        {renderEllipsis(totalPages)}
        {renderFirstAndLast(totalPages - 1)}
        {renderNextButton()}
      </ul>
    </nav>
  );
};

export default Pager;
